import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { useGetMerchantPricingsQuery } from "Api/Queries/Merchants/useGetMerchantPricingsQuery";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { DocumentsList } from "Components/LegalDocuments/DocumentsList";
import { Box, Skeleton } from "@mui/material";
import { getMerchantOrbitSPricingCategory } from "Utils/merchantPricingUtils";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.LegalDocuments.Documents.priceList;

export const MerchantCurrentPricingDocuments = () => {
  const { data: merchantData, isLoading: isMerchantLoading } =
    useGetMerchantQuery();
  const { data: allPricings, isLoading: isPricingsLoading } =
    useGetMerchantPricingsQuery();
  const { t } = useResource();

  const apiUrl = getApiUrl();

  if (isMerchantLoading || isPricingsLoading) {
    return (
      <Box py={3} px={4}>
        <Skeleton variant="text" height={24} width="25%" />
      </Box>
    );
  }

  if (!merchantData || !allPricings) {
    return null;
  }

  const pricingCategory = getMerchantOrbitSPricingCategory(
    merchantData.fees,
    allPricings,
  );

  if (!pricingCategory) {
    return null;
  }

  const document = {
    title: t(COMPONENT_RESOURCES[pricingCategory].title),
    url: t(COMPONENT_RESOURCES[pricingCategory].url, {
      apiUrl,
    }),
  };

  return <DocumentsList documents={[document]} />;
};
